module.exports = __webpack_public_path__ + "static/media/cliente-corporativa-agropecuaria.7b6c3cbc.webp";